// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Ecclesiasticus (Sirach)",
  bookSlug: "ecclesiasticus",
  chapter: 43,
  argument: "The works of God are exceedingly glorious and wonderful: no man is able sufficiently to praise him.",
  verses: [
    { n: 1, text: "The firmament on high is his beauty, the beauty of heaven with its glorious shew." },
    { n: 2, text: "The sun, when he appeareth shewing forth at his rising, an admirable instrument, the work of the Most High." },
    { n: 3, text: "At noon he burneth the earth; and who can abide his burning heat? As one keeping a furnace in works of heat:" },
    { n: 4, text: "The sun three times as much, burneth the mountains, breathing out fiery vapours, and shining with his beams, he blindeth the eyes." },
    { n: 5, text: "Great is the Lord that made him, and at his words he hath hastened his course." },
    { n: 6, text: "And the moon in all in her season, is for a declaration of times and a sign of the world." },
    { n: 7, text: "From the moon is the sign of the festival-day, a light that decreaseth in her perfection." },
    { n: 8, text: "The month is called after her name, increasing wonderfully in her perfection." },
    { n: 9, text: "Being an instrument of the armies on high, shining gloriously in the firmament of heaven." },
    { n: 10, text: "The glory of the stars is the beauty of heaven; the Lord enlighteneth the world on high." },
    { n: 11, text: "By the words of the holy one they shall stand in judgment, and shall never fail in their watches." },
    { n: 12, text: "Look upon the rainbow, and bless him that made it: it is very beautiful in its brightness." },
    { n: 13, text: "It encompasseth the heaven about with the circle of its glory, the hands of the Most High have displayed it." },
    { n: 14, text: "By his commandment he maketh the snow to fall apace, and sendeth forth swiftly the lightnings of his judgment." },
    { n: 15, text: "Through this are the treasures opened, and the clouds fly out like birds." },
    { n: 16, text: "By his greatness he hath fixed the clouds, and the hailstones are broken." },
    { n: 17, text: "At his sight shall the mountains be shaken, and at his will the south wind shall blow." },
    { n: 18, text: "The noise of his thunder shall strike the earth, so doth the northern storm, and the whirlwind:" },
    { n: 19, text: "And as the birds lighting upon the earth, he scattereth snow, and the falling thereof is as the coming down of locusts." },
    { n: 20, text: "The eye admireth at the beauty of the whiteness thereof, and the heart is astonished at the shower thereof." },
    { n: 21, text: "He shall pour frost as salt upon the earth: and when it freezeth, it shall become like the tops of thistles." },
    { n: 22, text: "The cold north wind bloweth, and the water is congealed into crystal: upon every gathering together of waters it shall rest, and shall clothe the waters as a breastplate." },
    { n: 23, text: "And it shall devour the mountains, and burn the wilderness, and consume all that is green as with fire." },
    { n: 24, text: "A present remedy of all is the speedy coming of a cloud, and a dew that meeteth it, by the heat that cometh, shall overpower it." },
    { n: 25, text: "At his word the wind is still, and with his thought he appeaseth the deep, and the Lord hath planted islands therein." },
    { n: 26, text: "Let them that sail on the sea, tell the dangers thereof: and when we hear with our ears, we shall admire." },
    { n: 27, text: "There are great and wonderful works: a variety of beasts, and of all living things, and the monstrous creatures of whales." },
    { n: 28, text: "Through him is established the end of their journey, and by his word all things are regulated." },
    { n: 29, text: "We shall say much, and yet shall want words: but the sum of our words is, He is all." },
    { n: 30, text: "What shall we be able to do to glorify him: for the Almighty himself is above all his works." },
    { n: 31, text: "The Lord is terrible, and exceeding great, and his power is admirable." },
    { n: 32, text: "Glorify the Lord as much as ever you can, for he will yet far exceed, and his magnificence is wonderful." },
    { n: 33, text: "Blessing the Lord, exalt him as much as you can: for he is above all praise." },
    { n: 34, text: "When you exalt him, put forth all your strength, and be not weary: for you can never go far enough." },
    { n: 35, text: "Who shall see him, and declare him? and who shall magnify him as he is from the beginning?" },
    { n: 36, text: "There are many things hidden from us that are greater than these: for we have seen but a few of his works." },
    { n: 37, text: "But the Lord hath made all things, and to the godly he hath given wisdom." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Shew. We cannot behold these things without admiration of God.", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "High. The sun is the most excellent of all irrational creatures, affording light (Worthington) and heat for the production of things; (Haydock) whence Aristotle (de Anima ii.) styles it \"father of men and of gods.\" Yet it is inferior to man, being devoid of reason. All creatures manifest God's majesty; the little as well as the great.", attribution: "Worthington" }
    ] },
    { verse: 5, notes: [
      { text: "Hastened. Some Greek copies read \"slackened,\" alluding to Josue x. 13.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "In all. Complutensian Greek, \"to stand guard.\" Other copies agree with the Vulgate, though embarrassed. — World. To mark out the seasons, Genesis i. 14., and Psalm ciii. 19.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Day. The lunar system prevailed only after the captivity. The Passover was celebrated on the 14th of the moon of Nisan.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Name. Meni is used for the moon, (Jeremias lxv. 11.) which resembles the Greek men, \"month.\" This is also derived from mene, \"the moon.\" We know not what Hebrew words were used, chap. vi. 23. The two former may both come from manah, \"to divide.\"", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Armies. The stars, &c., are compared to a camp or army.", attribution: "Haydock" }
    ] },
    { verse: 11, notes: [
      { text: "Judgment. The angels are not pure before God; (Job iv. 18., and xv. 15.) or rather the stars obey his orders, Baruch iii. 34., Judges v. 20., and Psalm cxviii. 91.", attribution: "Calmet" }
    ] },
    { verse: 12, notes: [
      { text: "Brightness. Mille trahit varios adverso sole colores.", attribution: "Virgil, �neid 5." }
    ] },
    { verse: 14, notes: [
      { text: "Judgment, to punish the wicked, Exodus xiv. 24., and Isaias xxxvii. 36.", attribution: "Calmet" }
    ] },
    { verse: 15, notes: [
      { text: "Birds, sent to give information by letters, as the Egyptians still do. (Bochart i. 2.) (Isaias lx. 8.) — Tempests execute God's judgments, Job xxxviii. 22.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "Broken, as from huge mountains, Job xxxviii. 39.", attribution: "Calmet" }
    ] },
    { verse: 18, notes: [
      { text: "Strike. Greek, \"upbraid, (Drusius) or make the earth fall in labour,\" odinesen. (Grabe)", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: "Lightning. Greek, \"flying, he.\" (Haydock) — Locusts. \"They cover the cornfields with a destructive cloud.\"", attribution: "Pliny, [Natural History?] xi. 29." }
    ] },
    { verse: 20, notes: [
      { text: "Shower, as if God were about to drown the world. The melting of snow occasions dreadful inundations. (Calmet) — Its whiteness sometimes deprives people of their sight.", attribution: "Xenophon, Anab. iv." }
    ] },
    { verse: 21, notes: [
      { text: "Thistles. Greek, \"stakes,\" pointed as it were with steel.", attribution: "Menochius" }
    ] },
    { verse: 22, notes: [
      { text: "Crystal, or ice.", attribution: "Calmet" }
    ] },
    { verse: 23, notes: [
      { text: "Burn. Cold destroys verdure no less than fire, Genesis xxxi. 40.", attribution: "Haydock" }
    ] },
    { verse: 24, notes: [
      { text: "Overpower it. Greek, \"give joy; (25.) with,\" &c. (Haydock) — Warmth and rain restore beauty to the earth, after the horrors of winter.", attribution: "Haydock" }
    ] },
    { verse: 25, notes: [
      { text: "Still. Literally, \"silent,\" Matthew viii. 26. — Lord. Roman Greek, \"Jesus planted it;\" which is a mistake for nesous, islands. (Calmet) — \"He planted islands in it.\" Grabe thus corrects the Alexandrian copy, though it agree with the Roman and Aldine editions.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "Thereof. Psalm cvi. 23. \"He who has not sailed has seen nothing evil.\"", attribution: "Possidip." }
    ] },
    { verse: 27, notes: [
      { text: "Monstrous. Greek, \"creation of whales.\"", attribution: "Haydock" }
    ] },
    { verse: 28, notes: [
      { text: "Is. Greek, \"his angel gives a prosperous journey.\" — Regulated. Greek, \"blended.\" (Haydock) — If God be angry, all will go to the bottom.", attribution: "Grotius" }
    ] },
    { verse: 29, notes: [
      { text: "All. Literally, \"in all.\" Every thing obeys God, chap. xlii. 15., and Ecclesiastes xii. 13.", attribution: "Haydock" }
    ] },
    { verse: 30, notes: [
      { text: "Him. So the Greek reads. Vulgate seems to say, \"boasting in all, what shall we be able to do?\" What is man, fighting against the Lord!", attribution: "Calmet" }
    ] },
    { verse: 32, notes: [
      { text: "His. Greek, \"exalting the Lord, exert your power; and labour, for you will not come up to him: (35.) who,\" &c. (Haydock) — He is above all praise, Psalm cxliv. 3.", attribution: "Calmet" }
    ] },
    { verse: 35, notes: [
      { text: "From. Greek, \"many hidden things are,\" &c. (Haydock) — The angels, and many secrets of nature, have not been mentioned.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
